import {Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	gap: 12px;
	padding: 16px;
	margin-bottom: 8px;
	box-sizing: border-box;
	border: ${({theme}) => `1px solid ${theme.palette.divider}`};
	border-radius: 8px;
`;

export {StyledStack};
